import { GetAttr } from './utils/getAttr'
import { parseJSON } from './utils/parseJSON'

export default class PageReload {

  els = {
    instance: '[data-js-page-reload]'
  }

  defaultCfg = {
    counter: 3
  }

  constructor () {
    this.instance = document.querySelector(this.els.instance)

    if (this.instance) {
      this.init()
    }
  }

  init () {
    this.cfg = this.getCfg()
    this.setPageReloadCountdown()
  }

  getMsFromMin (min) {
    return min * 60000
  }

  setPageReloadCountdown () {
    setTimeout(() => {
      location.reload()
    }, this.getMsFromMin(this.cfg.counter))
  }

  getCfg () {
    return { ...this.defaultCfg, ...parseJSON(this.instance.getAttribute(GetAttr(this.els.instance))) }
  }
}